import React from 'react'
import context from '@/context'
import { BsrsGrid, Column, commandColumnProps, EnumCellStatus, EnumFilterCell, NameColumn, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { localized } from '@/decorators/localized'
import { ReportSubmissionState } from '@/enums/ReportSubmissionState'
import { format } from '@/utils/StringUtilities'

@localized()
class AllReportSubmissionsGrid extends React.Component {
  render () {
    const { localize, locale, forecasting, detailUrlFormat } = this.props
    const enumName = 'ReportSubmissionState'
    return (
      <BsrsGrid persistenceId={'all-report-submissions' + (forecasting ? '-forecasting' : '')} dataSource={request => context.api.reportSubmissionService.getAllTableData(localize('Common.CBI'), forecasting, request)}
        defaultSort={[{ field: 'lastStateModificationTime', dir: 'desc' }]}>
        {NameColumn({ locale, nameProp: 'institutionName', latinNameProp: 'institutionLatinName', title: localize('Reporting.InstitutionName'), editable: false })}
        {NameColumn({ locale, nameProp: 'reportSubmissionGroupName', latinNameProp: 'reportSubmissionGroupLatinName', title: localize('Reporting.ReportSubmissionGroup'), editable: false })}
        <Column field='name' title={localize('Common.Name')} editable={false} />
        <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
        <Column field='state' title={localize('Common.Status')} editable={false}
          cell={EnumCellStatus({ localize, enumName, visualStatus: allReportSubmissionsStatus })}
          filterCell={EnumFilterCell({ localize, enumName }, ReportSubmissionState.values)} enumName={enumName} />
        <Column field='lastStateModificationTime' title={localize('Common.StatusChangedAt')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} width={100} />
        <Column field='lastStateModifierUserName' title={localize('Common.StatusChangedBy')} editable={false} />
        <Column field='creationTime' title={localize('Common.CreationTime')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} width={100} />
        <Column {...commandColumnProps({ detailUrl: x => format(detailUrlFormat, x.reportSubmissionGroupId, x.id) })} title=' ' width={80} />
      </BsrsGrid>
    )
  }
}

function allReportSubmissionsStatus (statusNumber) {
  switch (statusNumber) {
    case 0:
      return 'new'
    case 1:
      return 'unfinished'
    case 2:
      return 'accepted'
    case 3:
      return 'sent'
    case 4:
      return 'rejected'
    case 5:
      return 'accepted'
  }
  return 'new'
}

export default AllReportSubmissionsGrid



// WEBPACK FOOTER //
// ./src/components/reporting/allReportSubmissionsGrid.js